import Footer from '../footer';
import Head from '../head';
import Header from '../header';

import useTracking from '../../hooks/useTracking';
import useVendor from '../../hooks/useVendor';

const Layout = ({ storefrontConfig, campaignData, footerData, children = null }) => {
    const vendor = useVendor();
    const trackingData = useTracking(campaignData, campaignData.isBncl);

    return (
        <>
            <Head vendor={vendor} trackingDataLayer={trackingData} />
            <Header
                top={storefrontConfig.error ? [{}] : storefrontConfig.data.menus.top}
                mainMenu={storefrontConfig.error ? [{}] : storefrontConfig.data.menus.main}
                vendor={vendor}
            />
            {children}
            <Footer storefrontConfig={footerData.error ? [{}] : footerData.data} vendor={vendor} />
        </>
    );
};

export default Layout;
